import { createApp, h } from 'vue';
import {createRouter,createWebHistory} from "vue-router";
import Events from "./vue/events.vue";

const eventsApp = document.querySelector("#eventsApp");
if (eventsApp) {
    const eventsPageId = eventsApp.dataset.eventsPageId;
    const pageSize = eventsApp.dataset.pageSize;
    const seedData = {eventsPageId:eventsPageId,pageSize:pageSize};

    const router = createRouter({
        history: createWebHistory(),
        routes: [{path : window.location.pathname,component:Events}]
    });

    const events = createApp({
        data() { return seedData },
        render: () => h(Events)
    }, seedData);

    events.use(router);
    events.mount(eventsApp);

}
